exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-wrapper[data-v-4e5ee8a6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.upload-wrapper .download-template[data-v-4e5ee8a6]{margin-left:12px;color:#1890ff;font-size:14px;cursor:pointer}.upload-wrapper .download-template.disabled[data-v-4e5ee8a6]{cursor:not-allowed;pointer-events:none;opacity:.5}.upload-tips[data-v-4e5ee8a6]{margin-top:4px;color:#999;font-size:12px}", ""]);

// exports
